<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>

            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-form ref="formtarih" v-model="valid" lazy-validation>
                      <v-layout row wrap>

                        <v-flex xs12 sm12 md12>
                          <v-text-field label="Sayfa İsmi" :rules="[v => !!v || 'Gerekli Alan']"
                            v-model="pageClass.PageName"> </v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-text-field label="Sayfa Başlık" :rules="[v => !!v || 'Gerekli Alan']"
                            v-model="pageClass.PageTitle"> </v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-select item-text="text" :rules="[v => !!v || 'Gerekli Alan']" label="Sayfa Grubu"
                            item-value="value" :items="groupitems" v-model="pageClass.PageGroup"></v-select>
                        </v-flex>

                      </v-layout>
                    </v-form>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">
              <v-btn id="bguncelle" color="blue darken-1" flat @click="Kaydet()">Güncelle</v-btn>
              <!-- <v-btn id="bsil" color="blue darken-1" flat @click="deletehesap()">Sİl</v-btn> -->
            </div>

            <v-btn color="blue darken-1" flat @click="vazgec()">Vazgeç</v-btn>
            <div v-show="k === true">
              <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>Web Sayfası Tanımlama</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search">
        </v-text-field>

        <v-btn hidden="xs" flat @click="hesapekle()">Web Sayfası Ekle
          <v-icon right dark>add_box</v-icon>
        </v-btn>
      </v-toolbar>
    </v-layout>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :items="items" :loading="progress"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item)" item>
            <td class="text-xs-left">{{ props.item.PageName }}</td>
            <td class="text-xs-left">{{ props.item.PageTitle }}</td>
            <td class="text-xs-left">{{ props.item.PageGroup }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        valid: true,
        groupitems: [{
            text: 'Cari',
            value: 'Cari'
          },
          {
            text: 'Bilet',
            value: 'Bilet'
          },
          {
            text: 'Multi',
            value: 'Multi'
          },
        ],
        pageClass: {
          PageID: null,
          PageName: null,
          PageTitle: null,
          PageGroup: null
        },
        headers: [{
            text: 'Sayfa İsmi',
            value: 'PageName'
          },
          {
            text: 'Sayfa Başlık',
            value: 'PageTitle'
          }, {
            text: 'Sayfa Grubu',
            value: 'PageGroup'
          },



        ],
        loading: false,
        progress: false,
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        addgib: false,

        hesap: {
          Kod: '',
          Adi: '',
          Tipi: '',
        },
        state: [],
        dialog_baslik: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        text1: '',
        bankakod: '',
        bankaadi: '',
        dictionary: {
          custom: {
            gibseri: {
              required: () => 'Bu alan boş bırakılamaz',
              max: () => 'İki karakterden fazla olamaz'
            },
            sirketadi: {
              required: () => 'Bu alan boş bırakılamaz',
            }
          }
        }
      }
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      Getir(v) {
          var kayitlar= {
          PageID: v.PageID,
          PageName: v.PageName,
          PageTitle: v.PageTitle,
          PageGroup: v.PageGroup
        }

        this.pageClass = kayitlar
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Web Sayfası Güncelle'

      },
      deletehesap: deletehesap,
      hesapekle: hesapekle,
      Kaydet: Kaydet,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    vazgec: vazgec
  }


  function vazgec() {
    this.dialog = false
  }

  function Kaydet() {

    if (this.$refs.formtarih.validate()) {

      var params = this.pageClass

      this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageSave', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {



        this.text1 = response.body.ResponseMessage
        this.snackbar = true

        if (response.body.Status == true) {


          this.dialog = false

          this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageList', null, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.progress = false
          }, (response) => {
            if (response.status === 0) {
              this.progress = false

              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.progress = false

              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })

        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable.'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable.'
          this.snackbar = true
        }
      })
    }
  }





  function hesapekle() {

    this.dialog = true
    this.pageClass.PageTitle = null
    this.pageClass.PageName = null
    this.pageClass.PageGroup = 'Multi'

    this.dialog_baslik = 'Web Sayfası Ekle'
    this.m = false
    this.k = true
    this.$validator.reset()

  }

  function beforeMount() {
    this.progress = true

    this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageList', null, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.progress = false

        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.progress = false

        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }

  function deletehesap() {

    if (window.confirm('Hesap Gurubu\'nu silmek istediğinizden eminmisiniz?')) {

      this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageSave', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {



        this.text1 = response.body.ResponseMessage
        this.snackbar = true


        this.dialog = false

        this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageList', null, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.progress = false

            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.progress = false

            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })



      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable.'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable.'
          this.snackbar = true
        }
      })


    }
  }
</script>

<style>
</style>